import { useSelector } from "react-redux";
import { StyledTenantFlow } from "./styles";
import { selectSelectedTenant } from "../../../store/user/selectors";
import { Empty } from "antd";
import TenantDetails from "./TenantDetails";
import ConversionList from "./ConversionList";

const TenantFlow = () => {
  const selectedTenant = useSelector(selectSelectedTenant);

  return (
    <StyledTenantFlow xs={24} md={8} className="tenant-flow">
      {selectedTenant ? (
        <>
          <TenantDetails selectedTenant={selectedTenant} />
          <ConversionList />
        </>
      ) : (
        <div className="flex-center h-100">
          <Empty
            description="Please Select Business"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        </div>
      )}
    </StyledTenantFlow>
  );
};

export default TenantFlow;
